/**
 * Due-date chip logic (Tasks Module PRD §6).
 * Due dates are stored as 'YYYY-MM-DD' strings and compared against local
 * midnight. Never parse with new Date(str) — that reads as UTC and shifts
 * a day in negative-offset timezones.
 */

export const parseLocalDate = (dateStr) => {
  if (!dateStr) return null;
  const [y, m, d] = String(dateStr).split('-').map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
};

export const getDueChipProps = (dueDateStr, today = new Date()) => {
  const due = parseLocalDate(dueDateStr);
  if (!due) return null;

  const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const diffDays = Math.round((due - startOfToday) / (24 * 60 * 60 * 1000));
  const monthDay = due.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });

  if (diffDays < 0) {
    return { label: monthDay, bg: 'rgba(211,47,47,0.12)', color: '#d32f2f', bold: true };
  }
  if (diffDays === 0) {
    return { label: 'Today', bg: 'rgba(237,108,2,0.14)', color: '#ed6c02', bold: true };
  }
  if (diffDays === 1) {
    return { label: 'Tomorrow', bg: 'rgba(25,118,210,0.12)', color: '#1976d2', bold: false };
  }
  if (diffDays <= 7) {
    return { label: monthDay, bg: 'rgba(25,118,210,0.12)', color: '#1976d2', bold: false };
  }
  return { label: monthDay, bg: 'rgba(0,0,0,0.06)', color: 'rgba(0,0,0,0.6)', bold: false };
};
